var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notifications"}},_vm._l((_vm.notifications),function(item,index){return _c('div',{key:index,staticClass:"notification-container"},[_c('div',{staticClass:"notification",class:[item.type, item.class],on:{"click":function($event){return _vm.$notifications.close(item)}}},[_vm._v(_vm._s(item.msg))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }